import React from 'react';
import CryptoJS from 'crypto-js';

import { Row, Badge,Tooltip } from 'antd';
import { Link } from "react-router-dom";

class Products extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);    
        //当前组件状态
        this.state = {    
			hotFileList:[]
        }
    };
    
    componentDidMount(){
		this.requestHotFile()
    }
	
	requestHotFile=()=>{
	    // let url = "https://djangodev.moxidata.cn/tripvivid/artdetail/?method=hotfile_encrypt";
		let url = "https://gateway1.moxidata.cn/mktcharts/artkeywords/?method=hotfile_encrypt";   
	    let options = {
	        method: "GET",
	    }        
	        	        
	    //发起fetch
	    fetch(url, options).then(
	        (response) => {
	            // console.log("response",response);
	            return response.json()
	        }
	    ).then(    //若通信完成，从response中获取数据
	        (data) => {
	            // console.log("hotflie fetch data", data);
				var iv = CryptoJS.enc.Utf8.parse('delibejishanheqi');
				var key ='tudfstevaustweli'
				var Base64CBC = data.records;

				key = CryptoJS.enc.Utf8.parse(key);
				var decrypted =  CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC});
				decrypted = decrypted.toString(CryptoJS.enc.Utf8);
				var obj_records = JSON.parse(decrypted)
				console.log(obj_records)
				
	            this.setState({       //写入数据，setState会触发页面更新
					hotFileList:obj_records
	            })
	        }
	    ).catch(    //若出错，打印error
	        (error) => {
	            // console.log("111,",error)
	        }
	    )
	}
	
   
    render(){
		return(
			<div>
				<Row className="products-title" align="middle" justify="space-around">
					旗下多样化的产品
				</Row>

				<div className='products-body-v3'>
					<Row justify='space-around' wrap={false}>
						{/* 魔席招商 */}
						<a className="products-img-body-v3" href="https://app.moxidata.cn/moximerchants/moxiindex/"><img className='products-img-v3' src='/forest/image/moxi_v2.png' alt="moxi"></img></a>	
						{/* 文章敲敲乐 */}
						<Link className="products-img-body-v3" to="/forest/artkey"><img className='products-img-v3' src='/forest/image/artkey_v2.png' alt="artkey"></img></Link>
						{/* 聊聊数语 */}
						<a className="products-img-body-v3" href="https://app.moxidata.cn/moximodel/"><img className='products-img-v3' src='/forest/image/model_v2.png' alt="modelv2"></img></a>	
						{/* 可视数据 */}
						<a className="products-img-body-v3" href="https://app.moxidata.cn/newcharts/"><img className='products-img-v3' src='/forest/image/charts_v2.png' alt="newcharts"></img></a>
					</Row>
					
					<Row justify='space-around' wrap={false}>
					
						<Link className="products-img-body-v3" to="/forest/corpus"><img className='products-img-v3' src='/forest/image/corpus_v2.png' alt="corpus"></img></Link>
						<Link className="products-img-body-v3" to="/forest/policy"><img className='products-img-v3' src='/forest/image/policy_v2.png' alt="policy"></img></Link>
						<a className="products-img-body-v3" href="https://app.moxidata.cn/macroscopic/"><img className='products-img-v3' src='/wechatappfiles/forest/img/cities.png' alt="macroscopic"></img></a>		
						<Badge.Ribbon text="New!" color="#eb962f" className='badge-new'>
							<Tooltip title="景区流量已上线" placement="rightTop" color="#eb962f" key="cricgdpindex">
								<a className="products-img-body-v3" href="https://app.moxidata.cn/scenic/"><img className='products-img-v3' src='/forest/image/liuliang.jpeg' alt="liuliang"></img></a>	
							</Tooltip>
						</Badge.Ribbon>

					</Row>
					<Row justify='space-evenly' wrap={false}>
						<Link className="products-img-body-v3" to="/forest/hotText"><img className='products-img-v3' src='/forest/image/hottext.jpeg' alt="hotText"></img></Link>	
						{/* 地图 */}
						<a className="products-img-body-v3" href="https://app.moxidata.cn/newcharts/citiesmap/"><img className='products-img-v3' src='/forest/image/map3d.png' alt="citiesmap"></img></a>	
					</Row>
				</div>

			</div>
		);
		// 以下为无设计版，上方为设计师版
    }
        
}

export default Products;